// extracted by mini-css-extract-plugin
export default {"component":"MoneyInput_component__htZZC"};